(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["media-page"]) return;
  try {
    
document.querySelectorAll("[data-slider]").forEach((slider)=>{
  let slides = slider.querySelector(".media-slides");
  let imgs = slides.querySelectorAll("img");
  let progressBar = slider.querySelector(".media-progress-bar");
  let prevBack = slider.querySelector(".prevBack");
  let nextForward = slider.querySelector(".nextForward");
  let index = 0;

  function update(){
    slides.style.transform = `translateX(-${index * 100}%)`;
    progressBar.style.width = `${((index+1)/imgs.length)*100}%`;
  }
  prevBack.addEventListener("click", ()=>{ index=(index-1+imgs.length)%imgs.length; update(); });
  nextForward.addEventListener("click", ()=>{ index=(index+1)%imgs.length; update(); });
  update();

  /* --- SWIPE SUPPORT FOR SLIDER --- */
  let startX = 0, isDragging = false;
  slides.addEventListener("touchstart", (e)=>{
    startX = e.touches[0].clientX;
    isDragging = true;
  });
  slides.addEventListener("touchmove", (e)=>{
    if(!isDragging) return;
    let diff = e.touches[0].clientX - startX;
    // Prevent background scroll
    if(Math.abs(diff) > 10) e.preventDefault();
  }, {passive:false});
  slides.addEventListener("touchend", (e)=>{
    if(!isDragging) return;
    let endX = e.changedTouches[0].clientX;
    let diff = endX - startX;
    let threshold = 50; // minimum swipe distance
    if(diff > threshold){ index=(index-1+imgs.length)%imgs.length; }
    else if(diff < -threshold){ index=(index+1)%imgs.length; }
    update();
    isDragging = false;
  });

  // Lightbox
  const lightbox = document.getElementById("mediaLightbox");
  const lbImg = document.getElementById("lightboxImg");
  const lbprevBack = document.getElementById("lightboxprevBack");
  const lbnextForward = document.getElementById("lightboxnextForward");
  const lbClose = document.getElementById("lightboxClose");
  const lbProgress = document.getElementById("lightboxProgress");

  let lbIndex = 0;
  let activeImgs = null;

  slider.querySelector("[data-open-lightbox]").addEventListener("click", ()=>{
    activeImgs = imgs;
    lbIndex = index;
    lightbox.classList.add("active");
    document.body.classList.add("no-scroll");
    updateLightbox();
  });

  function updateLightbox(){
    if(!activeImgs) return;
    lbImg.src = activeImgs[lbIndex].src;
    lbProgress.style.width = `${((lbIndex+1)/activeImgs.length)*100}%`;
  }

  lbprevBack.addEventListener("click", ()=>{
    if(!activeImgs) return;
    lbIndex=(lbIndex-1+activeImgs.length)%activeImgs.length;
    updateLightbox();
  });
  lbnextForward.addEventListener("click", ()=>{
    if(!activeImgs) return;
    lbIndex=(lbIndex+1)%activeImgs.length;
    updateLightbox();
  });
  lbClose.addEventListener("click", ()=>{
    lightbox.classList.remove("active");
    document.body.classList.remove("no-scroll");
    activeImgs=null;
  });

  /* --- SWIPE SUPPORT FOR LIGHTBOX --- */
  let lbStartX = 0, lbDragging = false;
  lbImg.addEventListener("touchstart",(e)=>{
    lbStartX = e.touches[0].clientX;
    lbDragging = true;
  });
  lbImg.addEventListener("touchmove",(e)=>{
    if(!lbDragging) return;
    let diff = e.touches[0].clientX - lbStartX;
    if(Math.abs(diff) > 10) e.preventDefault();
  },{passive:false});
  lbImg.addEventListener("touchend",(e)=>{
    if(!lbDragging) return;
    let lbEndX = e.changedTouches[0].clientX;
    let diff = lbEndX - lbStartX;
    let threshold = 50;
    if(diff > threshold){ lbIndex=(lbIndex-1+activeImgs.length)%activeImgs.length; }
    else if(diff < -threshold){ lbIndex=(lbIndex+1)%activeImgs.length; }
    updateLightbox();
    lbDragging = false;
  });
});

  } catch(e) { console.error(e); }
})();
})();
